import { wccModules } from 'enums/wccModules';
import { inject, injectable } from 'inversify';
import { Subscribable } from 'knockout';
import { CollectionDataSource } from 'managers/datasources/collection';
import { EffectsContainer } from 'mixins/withEffects';
import PersonTiny, { JSONPersonTiny } from 'models/personTiny';
import { ServicesContext } from 'services/context';

const { accountId } = settings;

export interface TinyPeopleListManagerConfig {
    discussionId: string
    status: number,
    sortKey: string
}

interface QueryData {
    MembershipStatusType: number
    SortKey: string
}

@injectable()
export class TinyPeopleListManager {
    private discussionId: string
    private queryData: QueryData

    private source: CollectionDataSource<PersonTiny>
    

    people: Subscribable<Array<PersonTiny>>

    busy = ko.pureComputed(() => this.source.busy())
    loading = ko.pureComputed(() => this.source.busy() && this.source.requestsProcessed() === 0);
    updating = ko.pureComputed(() => this.source.busy() && this.source.requestsProcessed() > 0);

    constructor(
        @inject(wccModules.managerConfig) { discussionId, status, sortKey }: TinyPeopleListManagerConfig,
        @inject(wccModules.servicesContext) private ctx: ServicesContext,
        @inject(wccModules.effects) effects: EffectsContainer
    ) {
        this.discussionId = discussionId;

        this.queryData = {
            MembershipStatusType: status,
            SortKey: sortKey
        }

        this.source = effects.register(new CollectionDataSource({
            load: this.load.bind(this),
            update: this.update.bind(this),
            mapper: jsonPerson => new PersonTiny(jsonPerson)
        }));

        this.people = this.source.list;        

        if (accountId)
            ctx.peopleService.subscriptions.accountPeople.subscribe(accountId);

        ctx.peopleService.events.personChanged.on(this.onPersonChanged.bind(this));
    }

    private load() {
        return this.ctx
            .peopleService
            .queries
            .discussionParticipantsTiny(this.discussionId)
            .toArrayPost(this.queryData);
    }

    private async update(person: PersonTiny) {
        const jsonPerson: JSONPersonTiny = await this.ctx.peopleService.queries
            .discussionParticipantsTiny(this.discussionId)
            .addArgs({ '$filter': 'PersonId eq cast(' + person.personId() + ', Edm.Guid)' })
            .background()
            .firstOrDefaultPost(this.queryData);

        person.update(jsonPerson);
    }

    private onPersonChanged(personId: string) {
        this.source.update(person => person.personId() === personId);
    }
}